import { useAuth0 } from '@auth0/auth0-react';
import jwt_decode from 'jwt-decode';
import { useEffect, useState } from 'react';

const usePermissions = () => {
    const { getAccessTokenSilently } = useAuth0();
    const [data, setData] = useState<string[]>([]);
    const getAccessToken = async () => {
        const data = await getAccessTokenSilently();
        const decodedToken: any = jwt_decode(data);

        setData(decodedToken?.permissions);
    }

    useEffect(() => {
        getAccessToken();
    }, []);
    
    return data;
}

export default usePermissions;